var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58905 0 0 3.58821 0 8C0 12.4109 3.58905 16 8 16C12.4109 16 16 12.4109 16 8C16 3.58821 12.4109 0 8 0Z",
    fill: "url(#paint0_linear_9300_244128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.361 6.50239L7.47214 10.3912C7.34835 10.515 7.18751 10.5765 7.02583 10.5765C6.8633 10.5765 6.70246 10.515 6.57867 10.3912L4.63427 8.44681C4.38753 8.20007 4.38753 7.80007 4.63427 7.55333C4.88101 7.3066 5.28017 7.3066 5.5269 7.55333L7.02583 9.05144L10.4675 5.60888C10.7142 5.36214 11.1142 5.36214 11.361 5.60888C11.6077 5.85562 11.6077 6.25562 11.361 6.50239Z",
    fill: "url(#paint1_linear_9300_244128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9300_244128",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9300_244128",
    x1: 7.99763,
    y1: 5.42383,
    x2: 7.99763,
    y2: 10.5765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDone);
export default __webpack_public_path__ + "static/media/ic_done.a79b01cf507ddfdd811a5e9d0e56cb0c.svg";
export { ForwardRef as ReactComponent };